import { FlexRow } from '@gorila-shared-ui/components';
import { useRecoilState } from 'recoil';
import { useBreakpoints } from '../../hooks/useBreakpoints';
import { useStyles } from '../../hooks/useStyles';
import { wsTypeState } from '../../storage/logs';
import { ClientSelect } from '../shared/selects/ClientSelect';
import { SubClientSelect } from '../shared/selects/SubClientSelect';
import { WebServiceTypePicker } from '../shared/WebServiceTypePicker';

type Props = {
  selectedClientId?: string;
  selectedSubClientId?: string;
  setSelectedClientId: (clientId?: string) => void;
  setSelectedSubClientId: (subClientId?: string) => void;
};
export function WebServiceLogsFilters({
  selectedClientId,
  selectedSubClientId,
  setSelectedSubClientId,
  setSelectedClientId,
}: Readonly<Props>) {
  const { css, theme, classes } = useStyles();
  const [selectedWsType, setSelectedWsType] = useRecoilState(wsTypeState);
  const { isSmall } = useBreakpoints();

  const handleClientChange = (clientId?: string) => {
    if (clientId !== selectedClientId) {
      setSelectedClientId(clientId);
      setSelectedSubClientId(undefined);
    }
  };

  return (
    <FlexRow
      gap={theme.sizing.scale300}
      classNames={`${classes.fillParent} ${css({
        flexDirection: isSmall ? 'column' : 'row',
      })}`}
    >
      <WebServiceTypePicker
        onChange={setSelectedWsType}
        wsType={selectedWsType}
        maxWidth={isSmall ? undefined : 200}
        inline
        isFilter
      />
      <ClientSelect
        selectedClientId={selectedClientId}
        onChangeClientId={handleClientChange}
        inline
      />
      <SubClientSelect
        selectedClientId={selectedClientId}
        selectedSubClientId={selectedSubClientId}
        onChangeSubClientId={setSelectedSubClientId}
        disabled={!selectedClientId}
        inline
      />
    </FlexRow>
  );
}
